const colors = {
  ERROR: '#cf1322',
  WARNING: '#f0ad4e',
  SUCCESS: '#3f8600',
  PRIMARY: '#1E90FF',
};

export default colors;
